// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bc4m_5uwS7Sp0dvQnfCp{height:300px}`, "",{"version":3,"sources":["webpack://./services/client/src/components/progressBars/MultiFactorProgress/styles.module.scss"],"names":[],"mappings":"AAAA,sBAEE,YAAA","sourcesContent":[".chartContainer {\n//   width: 300px; \n  height: 300px;\n//   margin: 0 auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chartContainer": `bc4m_5uwS7Sp0dvQnfCp`
};
export default ___CSS_LOADER_EXPORT___;
